import React from "react";
import { IconProps } from "../icon";

export const Divide_03Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color || "#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 8h.01M12 16h.01M7 12h10m-4.5-4a.5.5 0 11-1 0 .5.5 0 011 0zm0 8a.5.5 0 11-1 0 .5.5 0 011 0zm9.5-4c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    />
  </svg>
);
